// WP-7.4 (RE-5): the Zakat estimate — "off by default; informational only". A plain query
// (not a mutation like `useCheckAffordability`): the owner navigates to the page and it loads
// automatically from their own already-saved nisab/rate settings, the same shape a report view
// already has, not an on-demand "check this one input" action.
import type { CurrencyCode } from '@pfos/engine';
import { zakatEstimateResponseSchema, type ZakatEstimateResponse } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export function useZakatEstimate(
  currency: CurrencyCode,
  nisabMinor: number,
  ratePercent: number,
): UseQueryResult<ZakatEstimateResponse> {
  return useQuery({
    queryKey: ['zakat', currency, nisabMinor, ratePercent],
    queryFn: async () => {
      const params = new URLSearchParams({
        currency,
        nisabMinor: String(nisabMinor),
        ratePercent: String(ratePercent),
      });
      return zakatEstimateResponseSchema.parse(
        await api.get(`/api/v1/reports/zakat?${params.toString()}`),
      );
    },
  });
}
